import React from 'react';
import { useTheme } from '@components/theme';
import classNames from 'classnames';

interface IAddToCartProps {
  handleAddToCart: () => void;
  buttonLabel: string;
  className?: string;
  isDisabled?: boolean;
}

const AddToCart = ({
  handleAddToCart,
  buttonLabel,
  className = undefined,
  isDisabled = false
}: IAddToCartProps) => {
  const theme = useTheme();

  return (
    <button
      className={classNames({
        [theme.styles.Disabled]: isDisabled
      }, className)}
      type="button"
      disabled={isDisabled}
      onClick={handleAddToCart}
      data-test="cart-button"
    >
      {buttonLabel}
    </button>
  );
};

export default AddToCart;

